import {takeEvery} from 'redux-saga/effects'
import {
  CHECK_GENERATE_VOUCHER_CHUNK,
  CLOSE_GENERATE_VOUCHER_RUN,
  CREATE_GENERATE_VOUCHER_RUN,
  GET_CURRENT_GENERATE_VOUCHER_RUN,
  GET_GENERATE_VOUCHER_OPTIONS,
  GET_GENERATE_VOUCHER_PREVIEW_STUDENTS,
  GET_GENERATE_VOUCHER_RUN,
  GET_GENERATE_VOUCHER_RUNS,
  GET_GENERATE_VOUCHER_STUDENTS,
  PREVIEW_GENERATE_VOUCHERS,
  RUN_GENERATE_VOUCHER_CHUNK,
} from 'setup/redux/Actions/GenerateVoucher/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* generateVoucherSagas() {
  yield takeEvery(GET_GENERATE_VOUCHER_OPTIONS, fetchData)
  yield takeEvery(GET_GENERATE_VOUCHER_STUDENTS, fetchData)
  yield takeEvery(PREVIEW_GENERATE_VOUCHERS, fetchData)
  yield takeEvery(GET_GENERATE_VOUCHER_PREVIEW_STUDENTS, fetchData)
  yield takeEvery(CREATE_GENERATE_VOUCHER_RUN, fetchData)
  yield takeEvery(GET_CURRENT_GENERATE_VOUCHER_RUN, fetchData)
  yield takeEvery(GET_GENERATE_VOUCHER_RUN, fetchData)
  yield takeEvery(GET_GENERATE_VOUCHER_RUNS, fetchData)
  yield takeEvery(RUN_GENERATE_VOUCHER_CHUNK, fetchData)
  yield takeEvery(CHECK_GENERATE_VOUCHER_CHUNK, fetchData)
  yield takeEvery(CLOSE_GENERATE_VOUCHER_RUN, fetchData)
}

export default generateVoucherSagas
